import { Text } from "troika-three-text";

export function addTextObject(
  object,
  value = "",
  side = "front",
  fontSize = 0.1,
) {
  const textObjectExists = object.children.find((child) => child.name === side);
  if (textObjectExists) return;

  if (value?.length > 50) value = value.slice(0, 50);

  const text = new Text();
  text.name = side;
  text.text = value;
  text.fontSize = fontSize;
  text.color = "black";
  text.anchorX = 0.2;
  text.anchorY = -0.2;
  text.overflowWrap = "break-word";
  text.maxWidth = 0.4;
  text.clipRect = [-0.2, -0.2, 0.3, 0.3]; //[minX, minY, maxX, maxY];

  switch (side) {
    case "front":
      text.position.set(0, 0, 0.26);
      break;
    case "right":
      text.position.set(0.26, 0, 0);
      rotateObject(text, 90);
      break;
    case "left":
      text.position.set(-0.26, 0, 0);
      rotateObject(text, -90);
      break;
    case "back":
      text.position.set(0, 0, -0.26);
      rotateObject(text, 180);
      break;
    case "top":
      text.position.set(0, 0.26, 0);
      rotateObject(text, -90, "x");
      break;
    default:
      return;
  }

  object.add(text);
}

export function updateTextObject(
  object,
  value = "",
  side = "front",
  fontSize = 0.1,
) {
  const textObject = object.children.find((child) => child.name === side);

  if (!textObject) return;
  if (value?.length > 50) value = value.slice(0, 50);

  textObject.userData.previousText = textObject.text;
  textObject.text = value;
  textObject.fontSize = fontSize;
}

function rotateObject(object, degrees, axis = "y") {
  const radians = degrees * (Math.PI / 180);
  object.rotation[axis] = radians;
}
